var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-product"},[_c('h1',[_vm._v("Product Page")]),_c('form',{attrs:{"action":"/cart/add"}})])}]

export { render, staticRenderFns }